import { useState, useEffect } from "react";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";

const usePillarTableExportFileSizeValues = () => {
  const { dataQuery, tableRowResults, totalResults, filtersRequest } =
    usePillarTableContext<any, any>();
  const [estimatedFileSizeKb, setEstimatedFileSizeKb] = useState<number>(0);
  const [averageRowSizeBytes, setAverageRowSizeBytes] = useState<number>(0);

  useEffect(() => {
    // Convert the data to a JSON string and calculate byte size
    const dataSize = new TextEncoder().encode(
      JSON.stringify(tableRowResults ?? []),
    ).length;
    // Divided by the number of results to get the average size of each row
    const averageRowSizeBytesCalc = dataSize / (tableRowResults.length ?? 1);
    setAverageRowSizeBytes(averageRowSizeBytesCalc);
    // Estimate the file size by multiplying the average row size by the total number of records.
    // Always update so the estimate reflects the current filter's result set,
    // preventing a stale high value from triggering unnecessary chunked pagination
    // after a filter reduces the total results.
    const newEstimatedFileSizeKb =
      (averageRowSizeBytesCalc * (totalResults ?? 1)) / 1024;
    setEstimatedFileSizeKb(newEstimatedFileSizeKb);
  }, [totalResults, tableRowResults]);
  return {
    estimatedFileSizeKb,
    averageRowSizeBytes,
  };
};

export default usePillarTableExportFileSizeValues;
